import { PageLayout } from "@ezmid/components-library";
import { useTranslation } from "react-i18next";

import { PaymentsListPageContent } from "../organisms/PaymentsListPageContent";

export function PaymentsListPage() {
  const { t } = useTranslation();
  return (
    <PageLayout title={t("app.page.payments.heading")}>
      <PaymentsListPageContent />
    </PageLayout>
  );
}
